/* ------------------------------------------ GRYFF FONT PICKER - T 08.09.2016 ----------------------------------------- */
import HELPER from '@/app/utils/HELPER';
import { app } from '@/store';
import { arrayMap } from '@/app/utils/nativeArray';
import emitter from '@/emitter';
import { renderFontList } from '@/app/editor/sidebar/utils/fontPicker';
import store from '@/app/store/store';
(function (jQuery) {
  jQuery.gfFontPicker = function (element, options) {
    const defaults = {
      api: '//fonts.googleapis.com/css?family=',
      title: '',
    };
    this.settings = {};

    const $element = jQuery(element);
    const _this = this;

    let _fontInit = [];

    /* Editor */
    const $gfLeftSideBar = jQuery('#gfLeftSideBar');
    const $divTopBar = jQuery('#divTopBar');
    const $divContentHidden = jQuery('#divContentHidden');

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');

    const _defaultFonts = [
      { googleName: 'ABeeZee', styleName: 'ABeeZee', fontWeight: '400' },
      { googleName: 'Abril+Fatface', styleName: 'Abril Fatface', fontWeight: '400' },
      { googleName: 'Acme', styleName: 'Acme', fontWeight: '400' },
      { googleName: 'Alegreya', styleName: 'Alegreya', fontWeight: '400,700' },
      { googleName: 'Alegreya+Sans', styleName: 'Alegreya Sans', fontWeight: '400,700' },
      { googleName: 'Anton', styleName: 'Anton', fontWeight: '400' },
      { googleName: 'Arimo', styleName: 'Arimo', fontWeight: '400,700' },
      { googleName: 'Arizonia', styleName: 'Arizonia', fontWeight: '400' },
      { googleName: 'Arvo', styleName: 'Arvo', fontWeight: '400,700' },
      { googleName: 'Baloo+Bhaina', styleName: 'Baloo Bhaina', fontWeight: '400' },
      { googleName: 'Bitter', styleName: 'Bitter', fontWeight: '400,700' },
      { googleName: 'Cabin', styleName: 'Cabin', fontWeight: '400,700' },
      { googleName: 'Cherry+Swash', styleName: 'Cherry Swash', fontWeight: '400,700' },
      { googleName: 'Courgette', styleName: 'Courgette', fontWeight: '400' },
      { googleName: 'Crimson+Text', styleName: 'Crimson Text', fontWeight: '400,700' },
      { googleName: 'Diplomata+SC', styleName: 'Diplomata SC', fontWeight: '400' },
      { googleName: 'Domine', styleName: 'Domine', fontWeight: '400,700' },
      { googleName: 'Dosis', styleName: 'Dosis', fontWeight: '400,700' },
      { googleName: 'Exo', styleName: 'Exo', fontWeight: '400,700' },
      { googleName: 'Fira+Sans', styleName: 'Fira Sans', fontWeight: '400,700' },
      { googleName: 'Fjalla+One', styleName: 'Fjalla One', fontWeight: '400' },
      { googleName: 'Gentium+Basic', styleName: 'Gentium Basic', fontWeight: '400,700' },
      { googleName: 'Grand+Hotel', styleName: 'Grand Hotel', fontWeight: '400' },
      { googleName: 'Gravitas+One', styleName: 'Gravitas One', fontWeight: '400' },
      { googleName: 'Inconsolata', styleName: 'Inconsolata', fontWeight: '400,700' },
      { googleName: 'Indie+Flower', styleName: 'Indie Flower', fontWeight: '400' },
      { googleName: 'Josefin+Sans', styleName: 'Josefin Sans', fontWeight: '400,700' },
      { googleName: 'Karla', styleName: 'Karla', fontWeight: '400,700' },
      { googleName: 'Kreon', styleName: 'Kreon', fontWeight: '400,700' },
      { googleName: 'Krona+One', styleName: 'Krona One', fontWeight: '400' },
      { googleName: 'Lato', styleName: 'Lato', fontWeight: '400,700' },
      { googleName: 'League+Script', styleName: 'League Script', fontWeight: '400' },
      { googleName: 'Libre+Baskerville', styleName: 'Libre Baskerville', fontWeight: '400,700' },
      { googleName: 'Libre+Franklin', styleName: 'Libre Franklin', fontWeight: '400,700' },
      { googleName: 'Lobster', styleName: 'Lobster', fontWeight: '400' },
      { googleName: 'Lora', styleName: 'Lora', fontWeight: '400,700' },
      { googleName: 'Luckiest+Guy', styleName: 'Luckiest Guy', fontWeight: '400' },
      { googleName: 'Merriweather', styleName: 'Merriweather', fontWeight: '400,700' },
      { googleName: 'Montserrat', styleName: 'Montserrat', fontWeight: '400,700' },
      { googleName: 'Mrs+Sheppards', styleName: 'Mrs Sheppards', fontWeight: '400' },
      { googleName: 'Neuton', styleName: 'Neuton', fontWeight: '400,700' },
      { googleName: 'Niconne', styleName: 'Niconne', fontWeight: '400' },
      { googleName: 'Noto+Sans', styleName: 'Noto Sans', fontWeight: '400,700' },
      { googleName: 'Nunito', styleName: 'Nunito', fontWeight: '400,700' },
      { googleName: 'Open+Sans', styleName: 'Open Sans', fontWeight: '400,700' },
      { googleName: 'Oswald', styleName: 'Oswald', fontWeight: '400,700' },
      { googleName: 'Oxygen', styleName: 'Oxygen', fontWeight: '400,700' },
      { googleName: 'Pacifico', styleName: 'Pacifico', fontWeight: '400' },
      { googleName: 'Paytone+One', styleName: 'Paytone One', fontWeight: '400' },
      { googleName: 'Playball', styleName: 'Playball', fontWeight: '400' },
      { googleName: 'Playfair+Display', styleName: 'Playfair Display', fontWeight: '400,700' },
      { googleName: 'Poppins', styleName: 'Poppins', fontWeight: '400,700' },
      { googleName: 'PT+Mono', styleName: 'PT Mono', fontWeight: '400' },
      { googleName: 'PT+Sans', styleName: 'PT Sans', fontWeight: '400,700' },
      { googleName: 'PT+Serif', styleName: 'PT Serif', fontWeight: '400,700' },
      { googleName: 'Quattrocento+Sans', styleName: 'Quattrocento Sans', fontWeight: '400,700' },
      { googleName: 'Qwigley', styleName: 'Qwigley', fontWeight: '400' },
      { googleName: 'Raleway', styleName: 'Raleway', fontWeight: '400,700' },
      { googleName: 'Roboto', styleName: 'Roboto', fontWeight: '400,700' },
      { googleName: 'Roboto+Condensed', styleName: 'Roboto Condensed', fontWeight: '400,700' },
      { googleName: 'Roboto+Slab', styleName: 'Roboto Slab', fontWeight: '400,700' },
      { googleName: 'Rokkitt', styleName: 'Rokkitt', fontWeight: '400,700' },
      { googleName: 'Sacramento', styleName: 'Sacramento', fontWeight: '400' },
      { googleName: 'Sail', styleName: 'Sail', fontWeight: '400' },
      { googleName: 'Sedgwick+Ave+Display', styleName: 'Sedgwick Ave Display', fontWeight: '400' },
      { googleName: 'Shadows+Into+Light', styleName: 'Shadows Into Light', fontWeight: '400' },
      { googleName: 'Sigmar+One', styleName: 'Sigmar One', fontWeight: '400' },
      { googleName: 'Six+Caps', styleName: 'Six Caps', fontWeight: '400' },
      { googleName: 'Slabo+27px', styleName: 'Slabo 27px', fontWeight: '400' },
      { googleName: 'Source+Code+Pro', styleName: 'Source Code Pro', fontWeight: '400,700' },
      { googleName: 'Stalemate', styleName: 'Stalemate', fontWeight: '400' },
      { googleName: 'Titillium+Web', styleName: 'Titillium Web', fontWeight: '400,700' },
      { googleName: 'Tulpen+One', styleName: 'Tulpen One', fontWeight: '400' },
      { googleName: 'Ubuntu', styleName: 'Ubuntu', fontWeight: '400,700' },
      { googleName: 'Ultra', styleName: 'Ultra', fontWeight: '400' },
      { googleName: 'Unica+One', styleName: 'Unica One', fontWeight: '400' },
      { googleName: 'Vollkorn', styleName: 'Vollkorn', fontWeight: '400,700' },
      { googleName: 'Work+Sans', styleName: 'Work Sans', fontWeight: '400,700' },
      { googleName: 'Yellowtail', styleName: 'Yellowtail', fontWeight: '400' },
    ];
    const _oldFont = [
      'Aclonica',
      'Allan',
      'Annie+Use+Your+Telescope',
      'Anonymous+Pro',
      'Allerta+Stencil',
      'Allerta',
      'Amaranth',
      'Anton',
      'Architects+Daughter',
      'Arimo',
      'Artifika',
      'Arvo',
      'Asset',
      'Astloch',
      'Bangers',
      'Bentham',
      'Bevan',
      'Bigshot+One',
      'Bowlby+One',
      'Bowlby+One+SC',
      'Brawler',
      'Buda:300',
      'Cabin',
      'Calligraffitti',
      'Candal',
      'Cantarell',
      'Cardo',
      'Carter One',
      'Caudex',
      'Cedarville+Cursive',
      'Cherry+Cream+Soda',
      'Chewy',
      'Coda',
      'Coming+Soon',
      'Copse',
      'Corben',
      'Cousine',
      'Covered+By+Your+Grace',
      'Crafty+Girls',
      'Crimson+Text',
      'Crushed',
      'Cuprum',
      'Damion',
      'Dancing+Script',
      'Dawning+of+a+New+Day',
      'Didact+Gothic',
      'Droid+Sans',
      'Droid+Sans+Mono',
      'Droid+Serif',
      'EB+Garamond',
      'Expletus+Sans',
      'Fontdiner+Swanky',
      'Forum',
      'Francois+One',
      'Geo',
      'Give+You+Glory',
      'Goblin+One',
      'Gravitas+One',
      'Gruppo',
      'Hammersmith+One',
      'Holtwood+One+SC',
      'Homemade+Apple',
      'Inconsolata',
      'Indie+Flower',
      'IM+Fell+DW+Pica',
      'IM+Fell+DW+Pica+SC',
      'IM+Fell+Double+Pica',
      'IM+Fell+Double+Pica+SC',
      'IM+Fell+English',
      'IM+Fell+English+SC',
      'IM+Fell+French+Canon',
      'IM+Fell+French+Canon+SC',
      'IM+Fell+Great+Primer',
      'IM+Fell+Great+Primer+SC',
      'Irish+Grover',
      'Irish+Growler',
      'Istok+Web',
      'Josefin+Sans',
      'Josefin+Slab',
      'Judson',
      'Jura',
      'Just+Another+Hand',
      'Just+Me+Again+Down+Here',
      'Kameron',
      'Kenia',
      'Kranky',
      'Kreon',
      'Kristi',
      'La+Belle+Aurore',
      'Lato',
      'League+Script',
      'Lekton',
      'Limelight',
      'Lobster',
      'Lobster Two',
      'Lora',
      'Love+Ya+Like+A+Sister',
      'Loved+by+the+King',
      'Luckiest+Guy',
      'Maiden+Orange',
      'Mako',
      'Maven+Pro',
      'Meddon',
      'MedievalSharp',
      'Megrim',
      'Merriweather',
      'Metrophobic',
      'Michroma',
      'Miltonian Tattoo',
      'Miltonian',
      'Modern Antiqua',
      'Molengo',
      'Mountains of Christmas',
      'Muli',
      'Neucha',
      'Neuton',
      'News+Cycle',
      'Nixie+One',
      'Nobile',
      'Nova+Cut',
      'Nova+Flat',
      'Nova+Mono',
      'Nova+Oval',
      'Nova+Round',
      'Nova+Script',
      'Nova+Slim',
      'Nova+Square',
      'Nunito',
      'OFL+Sorts+Mill+Goudy+TT',
      'Old+Standard+TT',
      'Open+Sans',
      'Open+Sans+Condensed:300',
      'Orbitron',
      'Oswald',
      'Over+the+Rainbow',
      'Reenie+Beanie',
      'Pacifico',
      'Parisienne',
      'Patrick+Hand',
      'Paytone+One',
      'Permanent+Marker',
      'Philosopher',
      'Play',
      'Playfair+Display',
      'Podkova',
      'PT+Sans',
      'PT+Sans+Narrow',
      'PT+Serif',
      'PT+Serif Caption',
      'Puritan',
      'Quattrocento',
      'Quattrocento+Sans',
      'Radley',
      'Raleway:100',
      'Redressed',
      'Rock+Salt',
      'Roboto',
      'Rokkitt',
      'Ruslan+Display',
      'Schoolbell',
      'Shadows+Into+Light',
      'Shanti',
      'Sigmar+One',
      'Six+Caps',
      'Slackey',
      'Smythe',
      'Sniglet:800',
      'Special+Elite',
      'Stardos+Stencil',
      'Sue+Ellen+Francisco',
      'Sunshiney',
      'Swanky+and+Moo+Moo',
      'Syncopate',
      'Tangerine',
      'Tenor+Sans',
      'Terminal+Dosis+Light',
      'The+Girl+Next+Door',
      'Tinos',
      'Ubuntu',
      'Ultra',
      'Unkempt',
      'UnifrakturCook:bold',
      'UnifrakturMaguntia',
      'Varela',
      'Varela Round',
      'Vibur',
      'Vollkorn',
      'VT323',
      'Waiting+for+the+Sunrise',
      'Wallpoet',
      'Walter+Turncoat',
      'Wire+One',
      'Yanone+Kaffeesatz',
      'Yeseva+One',
      'Zeyada',
    ];

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      const isSettingGS = this.settings.globalStyleSetting;

      if (!isSettingGS) {
        $element.hide();
      }

      _this.setupFontSelector(true, isSettingGS);
      store.unset('handeResetToDefaultGS');
      store.onChange('handeResetToDefaultGS', () => {
        _this.setupFontSelector(false);
      });
    };

    this.getFonts = function () {
      return window._pageFonts;
    };

    this.checkLimitFont = function ($content) {
      if (window._pageFonts.length > 3) {
        $content.find('.gfFMMessage p').text('Warning, exceeding three fonts may slow your page.');
        $content.find('.gfFMMessage').addClass('showMessage');
      } else {
        $content.find('.gfFMMessage').removeClass('showMessage');
        $content.find('.gfFMMessage p').text('');
      }
      return false;
    };

    this.toggleNotify = function ($content, settings = { open: false, message: '' }) {
      if (settings.open) {
        $content.find('.gfFMMessage p').text(settings.message);
        $content.find('.gfFMMessage').addClass('showMessage');
      } else {
        $content.find('.gfFMMessage').removeClass('showMessage');
        $content.find('.gfFMMessage p').text('');
      }
      return false;
    };

    this.openModalFontManager = function ($fontManager, globalStyleSetting = false, $gfFontSelect) {
      $fontManager.gfModalNew({
        title: 'FONT MANAGER',
        header: 'noIcon',
        footer: 'footer',
        addLabel: 'Add custom font',
        backLabel: 'Back to font manager',
        height: 700,
        width: 544,
        left: $gfLeftSideBar.children().innerWidth(),
        top: $divTopBar.innerHeight(),
        onContent: function ($content) {
          function findRow(a) {
            const number1 = a / 3;
            const number2 = parseInt(number1);
            if (number1 >= number2) {
              return Math.ceil(number1);
            }
          }

          function findCol(a) {
            var a = a % 3;
            if (a == 1) {
              return 1;
            } else if (a == 2) {
              return 2;
            } else {
              return 3;
            }
          }

          //Cache Font
          _fontInit = [];
          for (var i = 0; i < window._pageFonts.length; i++) {
            _fontInit.push(window._pageFonts[i]);
          }

          let _content = '<div class="gfFontManager">';
          _content += '<div class="gfFMHeader">';
          _content +=
            '<svg class="need_a_name" height="16px" viewbox="0 0 16 16"><path d="M6.57,9.66c-1.68,0-3.05-1.37-3.05-3.06s1.37-3.06,3.05-3.06S9.62,4.9,9.62,6.59S8.26,9.66,6.57,9.66z M14,12.92l-3.68-3.7c0.52-0.75,0.83-1.65,0.83-2.63C11.15,4.06,9.1,2,6.57,2S2,4.06,2,6.59s2.05,4.59,4.57,4.59c1,0,1.92-0.33,2.68-0.88L12.92,14L14,12.92z" /></svg>';
          _content += '<input type="text" placeholder="Search Fonts" />';
          _content += '<span>clear filter</span>';
          _content += '<div class="gfFMMessage">';
          _content += '<p></p>';
          _content += '</div>';
          _content += '</div>';
          _content += '<div class="gfFMBody">';
          _content += '<div class="gfFMSave">';
          _content += '<h3>Saved</h3>';

          function hasStyleNameInit(googleName) {
            for (let i = 0; i < _defaultFonts.length; i++) {
              if (_defaultFonts[i].googleName == googleName) {
                return i;
              }
            }
            return -1;
          }

          // let publicPath = '/editor';

          // if (import.meta.env.VITE_APP_MODE === 'production') {
          //   publicPath = 'https://' + import.meta.env.VITE_APP_CF_URL + '/' + import.meta.env.VITE_APP_E_PATH;
          // }
          const publicPath = import.meta.env.VITE_APP_CF_URL;

          for (var i = 0; i < window._pageFonts.length; i++) {
            const index = hasStyleNameInit(window._pageFonts[i].googleName);
            var number = index + 1;
            var row = findRow(number);
            const yS = (row - 1) * 40;
            var col = findCol(number);
            const xS = (col - 1) * 240;
            if (window._pageFonts[i].styleName != 'Inherit') {
              if (index >= 0) {
                if (window._pageFonts[i].custom) {
                  _content += '<div class="gfFMItem" font="' + window._pageFonts[i].googleName + '">';
                  _content +=
                    '<p style="font-family:' +
                    window._pageFonts[i].styleName +
                    '">' +
                    window._pageFonts[i].styleName +
                    '<b>custom</b></p>';
                  _content +=
                    '<span class="gfFMItemIcon"><svg class="help-me-name-it-bruh" height="14px" viewBox="0 0 14 14"><path d="M7,0C3.1,0,0,3.1,0,7s3.1,7,7,7s7-3.1,7-7S10.9,0,7,0z M7,8.4l-2.8,2.8c-0.6-0.4-1-0.9-1.4-1.4L5.6,7L2.8,4.2c0.4-0.6,0.9-1,1.4-1.4L7,5.6l2.8-2.8c0.6,0.4,1,0.9,1.4,1.4L8.4,7l2.8,2.8c-0.4,0.6-0.9,1-1.4,1.4L7,8.4z" style="fill: #C5C5D6"/></svg></span>';
                  _content +=
                    '<span class="gfFMItemRemove"><svg class="help-me-name-it-bruh" height="14px" viewBox="0 0 14 14"><path d="M7,0C3.1,0,0,3.1,0,7s3.1,7,7,7s7-3.1,7-7S10.9,0,7,0z M7,8.4l-2.8,2.8c-0.6-0.4-1-0.9-1.4-1.4L5.6,7L2.8,4.2c0.4-0.6,0.9-1,1.4-1.4L7,5.6l2.8-2.8c0.6,0.4,1,0.9,1.4,1.4L8.4,7l2.8,2.8c-0.4,0.6-0.9,1-1.4,1.4L7,8.4z" style="fill: #C5C5D6"/></svg></span>';
                  _content += '</div>';
                } else {
                  _content += '<div class="gfFMItem" font="' + window._pageFonts[i].googleName + '">';
                  _content +=
                    '<p style="background-image:url(' +
                    publicPath +
                    '/images/fontManeger.v2.png);background-repeat: no-repeat;background-position: -' +
                    xS +
                    'px -' +
                    yS +
                    'px;background-size:720px;"></p>';
                  _content +=
                    '<span class="gfFMItemIcon"><svg class="help-me-name-it-bruh" height="14px" viewBox="0 0 14 14"><path d="M7,0C3.1,0,0,3.1,0,7s3.1,7,7,7s7-3.1,7-7S10.9,0,7,0z M7,8.4l-2.8,2.8c-0.6-0.4-1-0.9-1.4-1.4L5.6,7L2.8,4.2c0.4-0.6,0.9-1,1.4-1.4L7,5.6l2.8-2.8c0.6,0.4,1,0.9,1.4,1.4L8.4,7l2.8,2.8c-0.4,0.6-0.9,1-1.4,1.4L7,8.4z" style="fill: #C5C5D6"/></svg></span>';
                  _content +=
                    '<span class="gfFMItemRemove"><svg class="help-me-name-it-bruh" height="14px" viewBox="0 0 14 14"><path d="M7,0C3.1,0,0,3.1,0,7s3.1,7,7,7s7-3.1,7-7S10.9,0,7,0z M7,8.4l-2.8,2.8c-0.6-0.4-1-0.9-1.4-1.4L5.6,7L2.8,4.2c0.4-0.6,0.9-1,1.4-1.4L7,5.6l2.8-2.8c0.6,0.4,1,0.9,1.4,1.4L8.4,7l2.8,2.8c-0.4,0.6-0.9,1-1.4,1.4L7,8.4z" style="fill: #C5C5D6"/></svg></span>';
                  _content += '</div>';
                }
              } else {
                _content += '<div class="gfFMItem" font="' + window._pageFonts[i].googleName + '">';
                _content +=
                  '<p style="font-family:' +
                  window._pageFonts[i].styleName +
                  '">' +
                  window._pageFonts[i].styleName +
                  '<b>custom</b></p>';
                _content +=
                  '<span class="gfFMItemIcon"><svg class="help-me-name-it-bruh" height="14px" viewBox="0 0 14 14"><path d="M7,0C3.1,0,0,3.1,0,7s3.1,7,7,7s7-3.1,7-7S10.9,0,7,0z M7,8.4l-2.8,2.8c-0.6-0.4-1-0.9-1.4-1.4L5.6,7L2.8,4.2c0.4-0.6,0.9-1,1.4-1.4L7,5.6l2.8-2.8c0.6,0.4,1,0.9,1.4,1.4L8.4,7l2.8,2.8c-0.4,0.6-0.9,1-1.4,1.4L7,8.4z" style="fill: #C5C5D6"/></svg></span>';
                _content +=
                  '<span class="gfFMItemRemove"><svg class="help-me-name-it-bruh" height="14px" viewBox="0 0 14 14"><path d="M7,0C3.1,0,0,3.1,0,7s3.1,7,7,7s7-3.1,7-7S10.9,0,7,0z M7,8.4l-2.8,2.8c-0.6-0.4-1-0.9-1.4-1.4L5.6,7L2.8,4.2c0.4-0.6,0.9-1,1.4-1.4L7,5.6l2.8-2.8c0.6,0.4,1,0.9,1.4,1.4L8.4,7l2.8,2.8c-0.4,0.6-0.9,1-1.4,1.4L7,8.4z" style="fill: #C5C5D6"/></svg></span>';
                _content += '</div>';
              }
            }
          }

          _content += '</div>';
          _content += '<div class="gfFMResult">';
          _content += '<h3>Search Result</h3>';

          function hasStyleName(googleName) {
            for (let i = 0; i < window._pageFonts.length; i++) {
              if (window._pageFonts[i].googleName == googleName) {
                return true;
              }
            }
            return false;
          }

          for (var i = 0; i < _defaultFonts.length; i++) {
            var number = i + 1;
            var row = findRow(number);
            const y = (row - 1) * 40;
            var col = findCol(number);
            const x = (col - 1) * 240;

            if (_defaultFonts[i].custom) {
              if (hasStyleName(_defaultFonts[i].googleName)) {
                _content += '<div class="gfFMItem active" font="' + _defaultFonts[i].googleName + '"">';
                _content +=
                  '<p style="font-family:' +
                  _defaultFonts[i].styleName +
                  '">' +
                  _defaultFonts[i].styleName +
                  '<b>custom<b></p>';
              } else {
                _content += '<div class="gfFMItem" font="' + _defaultFonts[i].googleName + '"">';
                _content +=
                  '<p style="font-family:' +
                  _defaultFonts[i].styleName +
                  '">' +
                  _defaultFonts[i].styleName +
                  '<b>custom<b></p>';
              }
              _content +=
                '<span class="gfFMItemIcon"><svg class="help-me-name-it-bruh" height="14px" viewBox="0 0 14 14"><path d="M12,8H8v4H6V8H2V6h4V2h2v4h4V8z" style="fill: #C5C5D6"/></svg></span>';
              _content +=
                '<span class="gfFMItemAdd"><svg class="help-me-name-it-bruh" height="14px" viewBox="0 0 14 14"><path d="M12,8H8v4H6V8H2V6h4V2h2v4h4V8z" style="fill: #C5C5D6"/></svg></span>';
              _content +=
                '<span class="gfFMItemIconActive"><svg class="help-me-name-it-bruh" height="14px" viewBox="0 0 14 14"><path d="M10.3,3.5l-4.6,4l-1.8-2L2.8,6.5l2.9,3.8l5.4-5.9L10.3,3.5z M7,14c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S10.9,14,7,14z" style="fill: #11D99C"/></svg></span>';
              _content +=
                '<span class="gfFMItemRemove"><svg class="help-me-name-it-bruh" height="14px" viewBox="0 0 14 14"><path d="M7,0C3.1,0,0,3.1,0,7s3.1,7,7,7s7-3.1,7-7S10.9,0,7,0z M7,8.4l-2.8,2.8c-0.6-0.4-1-0.9-1.4-1.4L5.6,7L2.8,4.2c0.4-0.6,0.9-1,1.4-1.4L7,5.6l2.8-2.8c0.6,0.4,1,0.9,1.4,1.4L8.4,7l2.8,2.8c-0.4,0.6-0.9,1-1.4,1.4L7,8.4z" style="fill: #C5C5D6"/></svg></span>';

              _content += '</div>';
            } else {
              if (hasStyleName(_defaultFonts[i].googleName)) {
                _content += '<div class="gfFMItem active" font="' + _defaultFonts[i].googleName + '">';
                _content +=
                  '<p style="background-image:url(' +
                  publicPath +
                  '/images/fontManeger.v2.png);background-repeat: no-repeat;background-position: -' +
                  x +
                  'px -' +
                  y +
                  'px;background-size:720px;"></p>';
              } else {
                _content += '<div class="gfFMItem" font="' + _defaultFonts[i].googleName + '">';
                _content +=
                  '<p style="background-image:url(' +
                  publicPath +
                  '/images/fontManeger.v2.png);background-repeat: no-repeat;background-position: -' +
                  x +
                  'px -' +
                  y +
                  'px;background-size:720px;"></p>';
              }
              _content +=
                '<span class="gfFMItemIcon"><svg class="help-me-name-it-bruh" height="14px" viewBox="0 0 14 14"><path d="M12,8H8v4H6V8H2V6h4V2h2v4h4V8z" style="fill: #C5C5D6"/></svg></span>';
              _content +=
                '<span class="gfFMItemAdd"><svg class="help-me-name-it-bruh" height="14px" viewBox="0 0 14 14"><path d="M12,8H8v4H6V8H2V6h4V2h2v4h4V8z" style="fill: #C5C5D6"/></svg></span>';
              _content +=
                '<span class="gfFMItemIconActive"><svg class="help-me-name-it-bruh" height="14px" viewBox="0 0 14 14"><path d="M10.3,3.5l-4.6,4l-1.8-2L2.8,6.5l2.9,3.8l5.4-5.9L10.3,3.5z M7,14c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7S10.9,14,7,14z" style="fill: #11D99C"/></svg></span>';
              _content +=
                '<span class="gfFMItemRemove"><svg class="help-me-name-it-bruh" height="14px" viewBox="0 0 14 14"><path d="M7,0C3.1,0,0,3.1,0,7s3.1,7,7,7s7-3.1,7-7S10.9,0,7,0z M7,8.4l-2.8,2.8c-0.6-0.4-1-0.9-1.4-1.4L5.6,7L2.8,4.2c0.4-0.6,0.9-1,1.4-1.4L7,5.6l2.8-2.8c0.6,0.4,1,0.9,1.4,1.4L8.4,7l2.8,2.8c-0.4,0.6-0.9,1-1.4,1.4L7,8.4z" style="fill: #C5C5D6"/></svg></span>';

              _content += '</div>';
            }
          }

          _content += '</div>';
          _content += '</div>';
          _content += '</div>';
          $content.html(_content);
          _this.checkLimitFont($content);

          $content.find('.gfFMBody').addClass('optiscroll').optiscroll();

          $content
            .find('.gfFMHeader input')
            .off('keyup change paste')
            .on('keyup change paste', function () {
              const value = $(this).val().toLowerCase();
              if (value !== '') {
                $content.find('.gfFMHeader span').show();

                $content.find('.gfFMResult .gfFMItem').hide();
                const $item = $content.find('.gfFMResult .gfFMItem');
                for (let i = 0; i < $item.length; i++) {
                  const $that = $($item[i]);
                  if ($that.attr('font').toLowerCase().indexOf(value) >= 0) {
                    $that.show();
                  }
                }
              } else {
                $content.find('.gfFMResult .gfFMItem').show();
                $content.find('.gfFMHeader span').hide();
              }
            });

          $content
            .find('.gfFMHeader span')
            .off('click')
            .on('click', function () {
              $content.find('.gfFMHeader input').val('').change();
            });

          _this.applyEventsModal($content);
        },
        onAdd: function () {
          let html = '<div class="gfFontManagerAdd">';
          html += '<form action="#" method="POST">';
          html += '<div class="form-head">';
          html += '<div class="h">Add font to manager';
          html += '<span>Add custom font name you uploaded.</span>';
          html += '</div>';
          html += '</div>';
          html += '<button type="submit" class="gf-btn">ADD</button>';
          html += '<div class="form-inputs">';
          html +=
            '<input type="text" name="templateName" placeholder="Enter your custom font name..." autofocus="true">';
          html += '</div>';
          html +=
            '<p class="text-desc">This feature is made for developer who uploaded custom fonts into current theme and wanted to use these fonts in the editor.</p>';
          html += '</form>';
          html += '</div>';
          $fontManager.data('gfmodalnew').onPreview(html);
          let timeout = -1;
          $fontManager
            .find('.gfFontManagerAdd form')
            .off('submit')
            .on('submit', function (e) {
              e.preventDefault();
              const font = {
                googleName: '',
                styleName: '',
                fontWeight: '',
                custom: true,
              };
              const googleName = ($fontManager.find('.gfFontManagerAdd input').val() || '').trim();
              $fontManager.find('.gfFontManagerAdd input').siblings('.gf_input-message[gf-type]').remove();

              if (!googleName || !googleName.length) {
                const $warningMsg = jQuery(
                  '<p class="gf_input-message" gf-type="message">Font name must not be empty</p>',
                );
                $warningMsg.css({
                  color: '#e43f3f',
                  'font-size': '11px',
                  'text-align': 'left',
                });
                $warningMsg.insertAfter($fontManager.find('.gfFontManagerAdd input'));
                return;
              }

              if (_oldFont.indexOf(googleName) >= 0) {
                _this.toggleNotify($fontManager, { open: true, message: 'Font already existed!' });
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                  _this.toggleNotify($fontManager, { open: false, message: '' });
                  _this.checkLimitFont($fontManager);
                }, 4000);

                font['googleName'] = _oldFont[_oldFont.indexOf(googleName)];
                font['styleName'] = _oldFont[_oldFont.indexOf(googleName)];
                font['fontWeight'] = '400';
              } else {
                font['googleName'] = googleName;
                font['styleName'] = googleName;
                font['fontWeight'] = '400';
              }

              const found = _defaultFonts.find((x) => x.googleName == googleName);
              if (found) {
                _this.toggleNotify($fontManager, { open: true, message: 'Font already existed!' });
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                  _this.toggleNotify($fontManager, { open: false, message: '' });
                  _this.checkLimitFont($fontManager);
                }, 4000);

                font['googleName'] = font['googleName'];
                font['styleName'] = font['styleName'];
                font['fontWeight'] = font['fontWeight'];
              }

              function hasStyleNameInit(styleName) {
                for (var i = 0; i < _defaultFonts.length; i++) {
                  if (_defaultFonts[i].styleName == styleName) {
                    return i;
                  }
                }
                for (var i = 0; i < window._pageFonts.length; i++) {
                  if (window._pageFonts[i].styleName == styleName) {
                    return i;
                  }
                }
                return -1;
              }
              const index = hasStyleNameInit(font.googleName);
              if (index == -1) {
                window._pageFonts.push(font);
                if (jQuery.inArray(font.googleName, window._themeFonts) == -1) {
                  window._themeFonts.push(font.googleName);
                }

                let _content = '<div class="gfFMItem" font="' + font.googleName + '"">';
                _content += '<p style="font-family:' + font.styleName + '">' + font.styleName + '<b>custom</b></p>';
                _content +=
                  '<span class="gfFMItemIcon"><svg class="help-me-name-it-bruh" height="14px" viewBox="0 0 14 14"><path d="M7,0C3.1,0,0,3.1,0,7s3.1,7,7,7s7-3.1,7-7S10.9,0,7,0z M7,8.4l-2.8,2.8c-0.6-0.4-1-0.9-1.4-1.4L5.6,7L2.8,4.2c0.4-0.6,0.9-1,1.4-1.4L7,5.6l2.8-2.8c0.6,0.4,1,0.9,1.4,1.4L8.4,7l2.8,2.8c-0.4,0.6-0.9,1-1.4,1.4L7,8.4z" style="fill: #C5C5D6"/></svg></span>';
                _content +=
                  '<span class="gfFMItemRemove"><svg class="help-me-name-it-bruh" height="14px" viewBox="0 0 14 14"><path d="M7,0C3.1,0,0,3.1,0,7s3.1,7,7,7s7-3.1,7-7S10.9,0,7,0z M7,8.4l-2.8,2.8c-0.6-0.4-1-0.9-1.4-1.4L5.6,7L2.8,4.2c0.4-0.6,0.9-1,1.4-1.4L7,5.6l2.8-2.8c0.6,0.4,1,0.9,1.4,1.4L8.4,7l2.8,2.8c-0.4,0.6-0.9,1-1.4,1.4L7,8.4z" style="fill: #C5C5D6"/></svg></span>';
                _content += '</div>';
                $fontManager.find('.gfFMSave').append(_content);

                _this.checkLimitFont($fontManager);
                _this.applyEventsModal($fontManager);
              }

              $fontManager.data('gfmodalnew').offPreview();
            });
        },
        onClose: function () {
          window._pageFonts = _fontInit;
          $divContentHidden.find('#md-font-manager').remove();
          emitter.emit('changeFontManager', window._pageFonts);
        },
        onCancel: function () {
          window._pageFonts = _fontInit;
          $divContentHidden.find('#md-font-manager').remove();
          emitter.emit('changeFontManager', window._pageFonts);
        },
        onSave: function () {
          $divContentHidden.find('#md-font-manager').remove();
          if (globalStyleSetting) {
            emitter.emit('changeFontManager', window._pageFonts);
          } else {
            const $gfFontSelect = $element.next('.gfFontSelect');
            $gfFontSelect.find('select').data('gfdropdown').setSelect(window._pageFonts);
            $divContentHidden.find('#md-font-manager').remove();
            $gfFontSelect.find('select').data('gfdropdown').setHighlight();
          }

          // Save fonts list
          if (localStorage && window._pageFonts) {
            const fontList = [];
            for (let i = 0; i < window._pageFonts.length; i++) {
              if (
                window._pageFonts[i].googleName &&
                window._pageFonts[i].googleName != 'inherit' &&
                fontList.indexOf(window._pageFonts[i].googleName) == -1
              ) {
                let font = window._pageFonts[i].googleName;
                if (window._pageFonts[i].fontWeight) {
                  font += ':' + window._pageFonts[i].fontWeight;
                }
                fontList.push(font);
              }
            }

            const shop = $gfFrame.data('gfframe').getShopDomain();
            try {
              localStorage['gfFontList_' + shop] = JSON.stringify(fontList);
            } catch (e) {
              console.log('Can not save font list. Exceed local storage limit');
            }
          }
        },
      });
      $fontManager.data('gfmodalnew').onShow();
    };

    _this.setTemplate = function (isSettingGS) {
      let value = typeof $element.attr('value') !== 'undefined' ? $element.attr('value') : '';

      function hasInit(styleName) {
        const fontsLength = window._pageFonts.length;
        for (let i = 0; i < fontsLength; i++) {
          if (window._pageFonts[i].styleName == styleName) {
            return true;
          }
        }
        return false;
      }

      value = value.split(',');
      const valueLength = value.length;
      const addFonts = [];

      for (let i = 0; i < valueLength; i++) {
        value[i] = value[i].trim();
        if (!hasInit(value[i])) {
          if (value[i] == '' || value[i] == 'inherit' || value[i] == 'Inherit') {
            break;
          }
          if (value[i].indexOf('"') >= 0) {
            break;
          }

          const item = {
            googleName: value[i], // name in google api
            styleName: value[i], // name in font-family css
            fontWeight: 400,
            custom: true,
          };

          addFonts.push(item);
        } else {
          for (let j = 0; j < window._pageFonts.length; j++) {
            if (value[i] == window._pageFonts[j].styleName) {
              value[i] = window._pageFonts[j].googleName;
            }
          }
        }
      }

      app.$store.dispatch('font/addFontOptionsAndLoadGoogleFonts', {
        fonts: addFonts,
      });

      if (isSettingGS) {
        const $fontManager = jQuery('<div id="md-font-manager"></div>');
        $divContentHidden.append($fontManager);
        _this.openModalFontManager($fontManager, isSettingGS);
      } else {
        let template = '<div class="gfFontSelect">';
        template += '<div class="gfSGSubTitle">' + this.settings.title + '</div>';
        template += '<div class="gfSGclear"></div>';
        template += '<div class="gfFSRight">';
        template += '<select value="' + value[0] + '">';

        const optionHtmls = arrayMap(
          window._pageFonts,
          (font) => `<option value="${font.googleName}">${font.styleName}</option>`,
        );
        template += optionHtmls.join('');

        template += '</select>';
        template += '</div>';
        template += '<div class="gfFSFull">open <span class="gfFSLeft">Font manager</span></div>';
        template += '</div>';

        $element.after(template);

        const $gfFontSelect = $element.next('.gfFontSelect');
        $gfFontSelect.find('select').gfDropDown({
          onSelected: function (value) {
            // Do nothing
            HELPER.addFontLink(value);

            for (let i = 0; i < window._pageFonts.length; i++) {
              if (window._pageFonts[i].googleName == value) {
                if (window._pageFonts[i].styleName == 'Inherit') {
                  value = '';
                }
                $element
                  .attr('value', window._pageFonts[i].styleName)
                  .val(window._pageFonts[i].styleName)
                  .trigger('input-change')
                  .trigger('font-change');
                _this.settings.onSelected(window._pageFonts[i].styleName);
              }
            }
          },
        });

        $gfFontSelect
          .find('.gfFSLeft')
          .off('click')
          .on('click', function () {
            const $fontManager = jQuery('<div id="md-font-manager"></div>');
            $divContentHidden.append($fontManager);
            _this.openModalFontManager($fontManager, false, $gfFontSelect);
          });
      }

      return false;
    };

    this.applyEventsModal = function ($content) {
      $content
        .find('.gfFMResult .gfFMItem')
        .off('click')
        .on('click', function (e) {
          e.preventDefault();
          var font = $(this).attr('font');
          const cacheHeight = $content.find('.gfFMBody .optiscroll-content')[0].scrollHeight;
          const oldTop = $content.find('.gfFMBody .optiscroll-content').scrollTop();
          if (!$(this).hasClass('active')) {
            $(this).addClass('active');
            let _item = '<div class="gfFMItem" font="' + font + '">';
            _item += '<p style="' + $(this).find('p').attr('style') + '">' + $(this).find('p').html() + '</p>';
            _item +=
              '<span class="gfFMItemIcon"><svg class="help-me-name-it-bruh" height="14px" viewBox="0 0 14 14"><path d="M7,0C3.1,0,0,3.1,0,7s3.1,7,7,7s7-3.1,7-7S10.9,0,7,0z M7,8.4l-2.8,2.8c-0.6-0.4-1-0.9-1.4-1.4L5.6,7L2.8,4.2c0.4-0.6,0.9-1,1.4-1.4L7,5.6l2.8-2.8c0.6,0.4,1,0.9,1.4,1.4L8.4,7l2.8,2.8c-0.4,0.6-0.9,1-1.4,1.4L7,8.4z" style="fill: #C5C5D6"/></svg></span>';
            _item +=
              '<span class="gfFMItemRemove"><svg class="help-me-name-it-bruh" height="14px" viewBox="0 0 14 14"><path d="M7,0C3.1,0,0,3.1,0,7s3.1,7,7,7s7-3.1,7-7S10.9,0,7,0z M7,8.4l-2.8,2.8c-0.6-0.4-1-0.9-1.4-1.4L5.6,7L2.8,4.2c0.4-0.6,0.9-1,1.4-1.4L7,5.6l2.8-2.8c0.6,0.4,1,0.9,1.4,1.4L8.4,7l2.8,2.8c-0.4,0.6-0.9,1-1.4,1.4L7,8.4z" style="fill: #C5C5D6"/></svg></span>';
            _item += '</div>';

            for (var i = 0; i < _defaultFonts.length; i++) {
              if (_defaultFonts[i].googleName == font) {
                window._pageFonts.push(_defaultFonts[i]);
                $content.find('.gfFMSave').append(_item);

                var newHeight = $content.find('.gfFMBody .optiscroll-content')[0].scrollHeight;
                $content.find('.gfFMBody .optiscroll-content').scrollTop(oldTop + (newHeight - cacheHeight));

                _this.checkLimitFont($content);
                _this.applyEventsModal($content);
              }
            }
          } else {
            const $dad = $(this);
            var font = $dad.attr('font');
            $($dad).removeClass('active');
            $content.find('.gfFMSave .gfFMItem[font="' + font + '"]').remove();
            for (var i = 0; i < window._pageFonts.length; i++) {
              if (window._pageFonts[i].googleName == font) {
                window._pageFonts.splice(i, 1);
                var newHeight = $content.find('.gfFMBody .optiscroll-content')[0].scrollHeight;
                $content.find('.gfFMBody .optiscroll-content').scrollTop(oldTop + (newHeight - cacheHeight));
              }
            }
            _this.checkLimitFont($content);
            return false;
          }
        });

      $content
        .find('.gfFMSave .gfFMItem .gfFMItemRemove')
        .off('click')
        .on('click', function (e) {
          e.preventDefault();
          const $dad = $(this).parents('.gfFMItem');
          const font = $dad.attr('font');
          $($dad).remove();
          $content.find('.gfFMResult .gfFMItem[font="' + font + '"]').removeClass('active');
          for (let i = 0; i < window._pageFonts.length; i++) {
            if (window._pageFonts[i].googleName == font) {
              window._pageFonts.splice(i, 1);
            }
          }
          _this.checkLimitFont($content);
          _this.applyEventsModal($content);
          return false;
        });

      $content
        .find('.gfFMResult .gfFMItem .gfFMItemRemove')
        .off('click')
        .on('click', function (e) {
          e.preventDefault();
          const $dad = $(this).parents('.gfFMItem');
          const font = $dad.attr('font');
          $($dad).removeClass('active');
          $content.find('.gfFMSave .gfFMItem[font="' + font + '"]').remove();
          for (let i = 0; i < window._pageFonts.length; i++) {
            if (window._pageFonts[i].googleName == font) {
              window._pageFonts.splice(i, 1);
            }
          }
          _this.checkLimitFont($content);
          _this.applyEventsModal($content);
          return false;
        });

      return false;
    };

    // new font manager
    this.setupFontSelector = async function (needLoadData, isSettingGS = false) {
      if (isSettingGS) {
        await app.$store.dispatch('font/openFontManager', true);
        return;
      }

      const data = { settings: this.settings, $element };
      await renderFontList(needLoadData, data);
    };

    this.init();
  };
  jQuery.fn.gfFontPicker = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gffontpicker')) {
        const plugin = new jQuery.gfFontPicker(this, options);
        jQuery(this).data('gffontpicker', plugin);
      }
    });
  };
})(jQuery);
